import { render, staticRenderFns } from "./EndpointDetails.vue?vue&type=template&id=a67b972e&scoped=true&"
import script from "./EndpointDetails.vue?vue&type=script&lang=ts&"
export * from "./EndpointDetails.vue?vue&type=script&lang=ts&"
import style0 from "./EndpointDetails.vue?vue&type=style&index=0&id=a67b972e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67b972e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
